package com.findyourbuddies.website.data.legal

import kotlinx.serialization.Serializable

@Serializable
data class LegalDocumentDto(
    val version: String,
    val lastUpdated: String,
    val content: String,

    val locale: String = "fr-FR",
    val minAppVersion: String? = null,
    val forceAcceptance: Boolean = false,
)
